module.exports = __webpack_public_path__ + "27ec5a7f28c5d0c8f02181d2ab888958.svg";